export const apiConfig = {
  WEB_SERVICE_URL:  (process.env && process.env.REACT_APP_API),
}




